import Api from "./Api";

export default {
  /// CRUD
  async paginate(data) {
    return Api.post("/pedidos/paginate", data);
  },
  async ver(id) {
    return Api.get("/pedidos/ver/" + id);
  },
  async asignar_repartidor(data) {
    return Api.post("/pedidos/asignar_repartidor", data);
  },
  async cobrar_y_finalizar(pedido_id) {
    return Api.post("/pedidos/cobrar_y_finalizar", { pedido_id });
  },
  async en_produccion() {
    return Api.get("/pedidos/en_produccion");
  }
};
